import api from "./api";

// In-memory catalog cache so navigating between Home / Catalog / product pages
// reuses the already-fetched lists instead of refetching every mount.
const TTL_MS = 60 * 1000;
const store = {}; // key -> { ts, data, promise }

async function cachedGet(key, path) {
    const entry = store[key];
    const now = Date.now();
    if (entry && entry.data && now - entry.ts < TTL_MS) {
        return entry.data;
    }
    if (entry && entry.promise) {
        return entry.promise;
    }
    const promise = api
        .get(path)
        .then(({ data }) => {
            store[key] = { ts: Date.now(), data: data || [], promise: null };
            return store[key].data;
        })
        .catch((err) => {
            if (store[key]) store[key].promise = null;
            throw err;
        });
    store[key] = { ...(entry || {}), promise };
    return promise;
}

export function getProducts() {
    return cachedGet("products", "/products");
}

export function getBundles() {
    return cachedGet("bundles", "/bundles");
}

export function invalidateCatalog() {
    delete store.products;
    delete store.bundles;
}
